module.exports = __webpack_public_path__ + "static/media/24UHCHR18.b0ab30d3.jpg";